var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDealertrackServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "75F5F85E-DC79-40D0-91F1-CB00EDC7610B@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cox_dealerTrack_only-context",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active-call---car-open",
    transform: "translate(-78.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(53.000000, 365.446812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.17,11.71 L13.57,9.29 C13.66,9.14 13.62,8.95 13.49,8.84 L12.01,7.68 C12.04,7.46 12.06,7.23 12.06,7 C12.06,6.77 12.04,6.54 12.01,6.31 L13.49,5.15 C13.62,5.04 13.66,4.85 13.57,4.7 L12.17,2.28 C12.08,2.13 11.9,2.07 11.74,2.13 L10,2.83 C9.64,2.55 9.25,2.32 8.82,2.14 L8.56,0.29 C8.53,0.13 8.38,0 8.21,0 L5.41,0 C5.24,0 5.09,0.13 5.06,0.3 L4.8,2.15 C4.38,2.33 3.98,2.56 3.62,2.84 L1.88,2.14 C1.72,2.08 1.54,2.14 1.45,2.29 L0.05,4.71 C-0.04,4.86 6.2883726e-17,5.05 0.13,5.16 L1.61,6.32 C1.58,6.54 1.56,6.77 1.56,7 C1.56,7.23 1.58,7.46 1.61,7.69 L0.13,8.85 C6.2883726e-17,8.96 -0.04,9.15 0.05,9.3 L1.45,11.72 C1.54,11.87 1.72,11.93 1.88,11.87 L3.62,11.17 C3.98,11.45 4.37,11.68 4.8,11.86 L5.06,13.71 C5.09,13.87 5.24,14 5.41,14 L8.21,14 C8.38,14 8.53,13.87 8.56,13.7 L8.82,11.85 C9.24,11.67 9.64,11.44 10,11.16 L11.74,11.86 C11.9,11.92 12.08,11.86 12.17,11.71 Z M6.81,9 C5.71,9 4.81,8.1 4.81,7 C4.81,5.9 5.71,5 6.81,5 C7.91,5 8.81,5.9 8.81,7 C8.81,8.1 7.91,9 6.81,9 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.92,16.67 L18.96,15.93 C18.98,15.79 19,15.64 19,15.49 C19,15.34 18.99,15.19 18.96,15.05 L19.91,14.31 C19.99,14.24 20.02,14.12 19.96,14.02 L19.06,12.47 C19.01,12.37 18.89,12.34 18.78,12.37 L17.67,12.82 C17.44,12.64 17.19,12.49 16.91,12.38 L16.74,11.2 C16.73,11.08 16.63,11 16.53,11 L14.74,11 C14.63,11 14.53,11.08 14.52,11.19 L14.35,12.37 C14.08,12.49 13.82,12.63 13.59,12.81 L12.48,12.36 C12.38,12.32 12.26,12.36 12.2,12.46 L11.3,14.01 C11.25,14.11 11.26,14.23 11.35,14.3 L12.3,15.04 C12.28,15.18 12.27,15.33 12.27,15.48 C12.27,15.63 12.28,15.78 12.3,15.92 L11.35,16.66 C11.27,16.73 11.24,16.85 11.3,16.95 L12.2,18.5 C12.25,18.6 12.37,18.63 12.48,18.6 L13.59,18.15 C13.82,18.33 14.07,18.48 14.35,18.59 L14.52,19.77 C14.54,19.88 14.63,19.96 14.74,19.96 L16.53,19.96 C16.64,19.96 16.74,19.88 16.75,19.77 L16.92,18.59 C17.19,18.47 17.45,18.33 17.67,18.15 L18.79,18.6 C18.89,18.64 19.01,18.6 19.07,18.5 L19.97,16.95 C20.03,16.86 20,16.74 19.92,16.67 Z M15.63,16.83 C14.89,16.83 14.28,16.23 14.28,15.48 C14.28,14.73 14.88,14.13 15.63,14.13 C16.38,14.13 16.98,14.73 16.98,15.48 C16.98,16.23 16.37,16.83 15.63,16.83 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealertrackServices);
export default __webpack_public_path__ + "static/media/dealertrack_services.b1bd9926.svg";
export { ForwardRef as ReactComponent };